import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Navigate, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Footer from './components/footer/Footer';
import ParticlesBackground from './components/particlesbackground/ParticlesBackground';
import Home from './containers/home/Home';
import './App.css';

const Aboutme = lazy(() => import('./containers/aboutme/Aboutme'));
const Proyectos = lazy(() => import('./containers/proyectos/Proyectos'));
const Viz = lazy(() => import('./containers/viz/Viz'));
const Proyecto = lazy(() => import('./pages/Proyecto'));
const Viz3 = lazy(() => import('./containers/viz/03-d3js/03d3js'));

const App = () => (
  <Router>
    <div className="App">
      <ParticlesBackground />
      <Navbar />
      <div className="portfolio__body">
        <Suspense fallback={<p role="status">Cargando página…</p>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-me" element={<Aboutme />} />
            <Route path="/projects" element={<Proyectos />} />
            <Route path="/projects/proyecto-4" element={<Navigate to="/projects/proyecto-1" replace />} />
            <Route path="/projects/:slug" element={<Proyecto categoria="projects" />} />
            <Route path="/data-viz" element={<Viz />} />
            <Route path="/data-viz/viz-3" element={<Viz3 />} />
            <Route path="/data-viz/:slug" element={<Proyecto categoria="data-viz" />} />
          </Routes>
        </Suspense>
      </div>
      <Footer />
    </div>
  </Router>
);

export default App;
